import { PrintArea, PrintType, Size } from '@/types';

export const fitsPrintAreaAndPrintType = (
  size: Size,
  { boundary: { size: printAreaSize } }: PrintArea,
  { size: printTypeSize }: PrintType
) =>
  size.width <= printAreaSize.width &&
  size.height <= printAreaSize.height &&
  size.width < printTypeSize.width &&
  size.height < printTypeSize.height;
